const categoryEmojiMap = {
  '1101': '🚐',
  '6082': '🐱',
  '1062': '⛵️',
}

export default (categoryId) => {
  return categoryEmojiMap[categoryId]
}
